import { Route, Routes } from 'react-router-dom'

import Alert from './Alert'
import AlertNone from './AlertNone'

// alert
const Index = () => {
	return (
		<Routes>
			<Route path="/alertNone" element={<AlertNone />} /> { /* 알림 메인 (내역이 없는 경우) */}
			<Route path="/" element={<Alert />} /> { /* 알림 메인 (내역이 있는 경우) */}
		</Routes>
	)
}

export default Index